import { Link } from "react-router-dom";
// import footerMenusStaticData from "./FooterBottom.json";
import { useGetProtectedApiDataQuery } from "../../../redux/services/apiSlice";
import { useSelector } from "react-redux";
const FooterBottomMenus = () => {
  const { languageType } = useSelector((state) => state.homeSlice);

  const { data: footerBottomMenus = {}, isLoading: footerBottomMenusLoading } =
    useGetProtectedApiDataQuery({
      url: "mastermenu-footer-last",
      lang: languageType,
    });

  const menuItems = Array.isArray(footerBottomMenus?.menu_items)
    ? footerBottomMenus.menu_items.filter((item) => item.status === true)
    : [];

  return (
    <div className="footer-nav-sec">
      <ul>
        {footerBottomMenusLoading ? (
          <li>Loading...</li>
        ) : menuItems.length > 0 ? (
          menuItems.map((item, index) => (
            <li key={index}>
              {item.external ? (
                <a
                  href={item.url}
                  title={item.title}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {item.title}
                </a>
              ) : (
                <Link to={item.url} title={item.title}>
                  {item.title}
                </Link>
              )}
            </li>
          ))
        ) : (
          <li>No menu found</li>
        )}
      </ul>
    </div>
  );
};

export default FooterBottomMenus;
